import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const Transmission = ({ transmission }: SpecProps<"transmission">) => {
  const { i18n } = useLingui();

  if (transmission == null) {
    return null;
  }

  const field = i18n._({
    id: "itemPageLayout.common.transmission.label",
    message: "Transmission",
    comment: "'Transmission' label",
  });

  const value = typeof transmission === "string" ? transmission : transmission.value;

  return <FieldValuePair field={field} value={value} />;
};
